import { CustomTextInput, CustomPINInput } from "../../Components/FormElements";
import { CustomFileInput } from "../../Components/FormElements";
import { PrimaryButton, SecondaryButton } from "../../Components/Buttons";
import { useState, useEffect } from "react";
import APIService from "../../Services/api-service";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
// Custom styles
import style from "../../Styles/Components/funds.module.scss";
import { useCountdown } from "../../Helper/helper";
import { useParams } from "react-router-dom";

function ImportExternalFundsModal(props) {
  const [openItem, setOpenItem] = useState("");
  const [photoError, setPhotoError] = useState("");
  const [photoUploader, setPhotoUploader] = useState("");
  const [photo, setPhoto] = useState("");
  const [photoUrl, setPhotoUrl] = useState("");

  const PROGRESS_DATA = useSelector((state) => state.Reducer.SIGNUP_PROGRESS);
  const PROFILE_DETAILS = useSelector((state) => state.Reducer.PROFILE_DETAILS);

  const _hasPan = PROFILE_DETAILS?.pan !== null && PROFILE_DETAILS?.pan !== "" && PROFILE_DETAILS?.pan !== undefined;

  const [transactionPhoto, setTransactionPhoto] = useState(() => {
    return sessionStorage.getItem("external_transaction_photo") || "";
  });
  const [transactionPhotoUrl, setTransactionPhotoUrl] = useState(() => {
    return sessionStorage.getItem("external_transaction_photo_url") || "";
  });
  const [transactionPhotoError, setTransactionPhotoError] = useState("");
  const [panVerified, setPanVerified] = useState(false);
  const [transactionQRGenerated, setTransactionQRGenerated] = useState(false);

  const [initiateLoader, setInitiateLoader] = useState(false);
  const [qrLoader, setQrLoader] = useState(false);

  const [panError, setPanError] = useState("");
  const [pan, setPan] = useState(
    PROFILE_DETAILS?.pan !== null ? PROFILE_DETAILS.pan : "",
  );

  const [verifyStep, setVerifyStep] = useState();
  const [panLocked, setPanLocked] = useState(_hasPan);
  const [uploadLoader, setUploadLoader] = useState(false);

  const { id, flag, type } = useParams();
  const isTransactionType = type === "transaction";

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        const base64WithPrefix = reader.result;

        // remove prefix
        const rawBase64 = base64WithPrefix.split(",")[1];

        resolve(rawBase64);
      };

      reader.onerror = (error) => reject(error);
    });
  };

  const _uploadQR = async (qrType, base64) => {
    setUploadLoader(true);

    const url = "/mf-services-cas/upload-qr";

    const request = {
      qr_type: qrType,
      qr_code_base64: base64,
    };
    // ✅ Debug log here
    // console.log("Uploading QR", {
    //   type: qrType,
    //   base64_length: base64.length,
    // });
    try {
      const response = await APIService(true, url, request);

      toast.dismiss();

      if (response.status_code === 200) {
        toast.success("Transaction QR uploaded successfully");

        if (qrType === "transaction") {
          setTransactionPhoto(base64);
          sessionStorage.setItem("external_transaction_photo", base64);
          setOpenItem(null);
          sessionStorage.setItem("external_qr_uploaded", "true");
          const currentUrl = window.location.href;
          const baseUrl = currentUrl.split('?')[0];
          window.history.replaceState({}, '', baseUrl);
        }
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("QR upload failed");
    }

    setUploadLoader(false);
  };

  async function handlePhoto(file, type) {
    if (file.size > 5242880) {
      toast.error("Upload image below 5MB");
      return;
    }

    if (!file.type.includes("image")) {
      toast.error("Only PNG or JPG allowed");
      return;
    }

    try {
      const base64 = await convertToBase64(file);
      if (type === "transaction") {
        setTransactionPhotoUrl(URL.createObjectURL(file));
        await _uploadQR("transaction", base64);
      }
    } catch (err) {
      toast.error("Image processing failed");
    }
  }
  function _handlePAN(input_value) {
    if (input_value.length <= 10) {
      setPan(input_value.toUpperCase());
    }
    // Don't reset error here, only reset on user typing maybe
    setPanError(""); // optional, only if you want error to clear while typing
  }

  const _initiateImport = (type = null) => {
    if (type === null) setInitiateLoader(true);

    const url = "/mf-services-cas/initiate";

    const request = {
      pan: pan.toUpperCase(),
    };

    APIService(true, url, request)
      .then((response) => {
        toast.dismiss();

        if (response?.status_code === 200) {
          toast.success("Pan is verified Successfully");

          setPanVerified(true);
          setPanLocked(true);
          setOpenItem("transaction");
        } else {
          const errorMessage =
            response?.message?.error?.message ||
            response?.message ||
            "PAN verification failed";

          toast.error(errorMessage);
        }
      })
      .catch((error) => {
        toast.error("Server error while verifying PAN");
      })
      .finally(() => {
        setInitiateLoader(false);
      });
  };

  const _finalSubmitAPI = async () => {
    setInitiateLoader(true);

    const url = "/mf-services-cas/submit-cas";

    try {
      const response = await APIService(true, url);

      toast.dismiss();

      if (response.status_code === 200) {
        toast.success("Submitted successfully");

        sessionStorage.removeItem("external_transaction_photo");
        sessionStorage.removeItem("external_transaction_photo_url");
        sessionStorage.removeItem("external_qr_uploaded");

        const currentUrl = window.location.href;
        const baseUrl = currentUrl.split('?')[0];
        window.history.replaceState({}, '', baseUrl);
        
        // ✅ Step 1: show loader
        setVerifyStep(5);

        // ✅ Step 2: move to success after delay
        setTimeout(() => {
          setVerifyStep(6);
        }, 3000); // 3 sec
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Something went wrong");
    }

    setInitiateLoader(false);
  };

  const _getPlatform = () => {
    const ua = navigator.userAgent || "";
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    if (isIOS) return "ios_web";
    const isMobileBrowser =
      /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    if (isMobileBrowser) return "android_web";
    return "web";
  };
  const _GenerateQR = async (type = null) => {
    try {
      
        setQrLoader(true);
      

      const url = "/mf-services-cas/get-transaction-qr-redirect";
      const request = {
        platform: _getPlatform(),
      };
      const response = await APIService(true, url, request);
      toast.dismiss();
      if (response.status_code === 200) {
        setTransactionQRGenerated(true);
        // localStorage.setItem("external_import_step", type);
        toast.success("Redirecting to generate QR");
        // window.open(response.data.redirect_url);
        window.open(response.data.redirect_url, "_self");

        //         const link = document.createElement('a');
        //   link.href = response.data.redirect_url;
        //   link.target = '_blank';
        //   link.rel = 'noopener noreferrer';
        //   document.body.appendChild(link);
        //   link.click();
        //   document.body.removeChild(link);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("QR generation failed");
    } finally {
      setQrLoader(false);
    }
  };
  useEffect(() => {
    const importFlag = flag === "true";
    const step = type;

    if (!importFlag) return;

    if (PROFILE_DETAILS?.pan) {
      setPan(PROFILE_DETAILS.pan);
    }

    setPanVerified(true);
    setPanLocked(true);

    if (step === "transaction") {
      setTransactionQRGenerated(true);
      setOpenItem("transaction");
      if (sessionStorage.getItem("external_qr_uploaded") === "true") {
        setOpenItem(null);
      }
    }
  }, [flag, type, PROFILE_DETAILS]);

  function _handleSubmit() {
    let valid = true;
    let pan_value = pan.toUpperCase().trim();

    // Skip frontend validation if PAN is already on file (masked)
    if (_hasPan && panLocked) {
      _initiateImport(null);
      return;
    }

    if (!pan_value) {
      setPanError("PAN is required");
      valid = false;
    } else {
      let validate_pan = /^[A-Z]{3}P[A-Z]{1}\d{4}[A-Z]{1}$/;
      if (!validate_pan.test(pan_value)) {
        setPanError("Invalid PAN number");
        valid = false;
      }
    }

    if (valid) {
      _initiateImport(null); // only call API
    }
  }

  // function handleFinalSubmit() {
  //   setVerifyStep(2); // open OTP modal
  // }

  function handleFinalSubmit() {
    // if (!summaryPhoto || !transactionPhoto)
    if (!transactionPhoto) {
      toast.error("Please upload transaction QR");
      return;
    }
    _finalSubmitAPI();
  }
  return (
    <>
      {verifyStep === 5 && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
          <div
            className={`modal-dialog position-relative modal-dialog-centered ${style.e_loader}`}
          >
            <div
              className={`modal-content text-center p-2 ${style.e_content} h-490px`}
            >
              <div className="my-auto">
                <img
                  src={require("../../Assets/Images/Loader/page-loader.gif")}
                  alt="loader"
                  width={80}
                  height={80}
                  className="mx-auto"
                />
                <h6 className="e-font-16 mt-3">
                  Fetching your external investment
                </h6>
              </div>
            </div>
          </div>
        </div>
      )}

      {verifyStep === 6 && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
          <div
            className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}
          >
            <div
              className={`modal-content text-center px-4 ${style.e_content}`}
            >
              <div className="my-auto py-4">
                <img
                  src={require("../../Assets/Images/External/success.png")}
                  alt="success"
                  width={108}
                  className="mx-auto mt-4"
                />

                <h5 className="mt-3">{props.title || "Import Successful"}</h5>

                <p>
                  {props.content ||
                    "Your external funds will appear in 10-15mins"}
                </p>

                {props.showButton && (
                  <PrimaryButton
                    label={props.label || "Continue"}
                    className="w-100 mt-4 mb-2"
                    onPress={props.onSuccessfulImport}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="box-shadow-33 border-lavender-blue p-4 bg-white w-100 mx-auto mb-4">
        {/* Header */}
        <div className="d-flex px-2 justify-content-center align-items-center mb-2">
          <h6 className="e-font-18 e-line-height-24 e-montserrat-semi-bold color-eerie-black mb-0">
            Import External Portfolio
          </h6>
        </div>

        {/* PAN Section */}
        <div className="d-flex align-items-center justify-content-center gap-16px p-3 border-radius-16px">
          <img
            src={require("../../Assets/Images/Portfolio/pan.png")}
            alt="pan"
            width={72}
            draggable={false}
          />
          <div className="d-block">
            <h6 className="color-eerie-black e-font-14 e-line-height-20 e-montserrat-medium mb-1">
              Enter your PAN
            </h6>
            <p className="color-eerie-black e-font-14 e-line-height-20 e-montserrat-regular mb-0">
              Required for your account verification
            </p>
          </div>
        </div>

        {/* PAN Input & Button */}
        <div className={style.verify_pan}>
          <div className="">
            <CustomTextInput
              label="Enter Your PAN"
              postfix="*"
              placeholder="Eg:AGH7898G"
              value={pan}
              inputClass="text-transform-upper"
              handleChange={_handlePAN} // ✅ ADD THIS
              isDisabled={
                panLocked || PROGRESS_DATA?.kyc_data?.is_kyc_compliant === true
              }
            />
            {panError && (
              <p className="color-deep-carmine-pink e-font-12 e-montserrat-medium">
                {panError}
              </p>
            )}
          </div>
          <div className="">
            <PrimaryButton
              label={
                panVerified ? (
                  <span className="d-inline-flex align-items-center">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    Verified
                  </span>
                ) : (
                  "Verify"
                )
              }
              className="padding-12px-tb w-100"
              disabled={panVerified || initiateLoader}
              showLoader={initiateLoader}
              onPress={_handleSubmit}
            />
          </div>
        </div>

        {/* Accordion */}
        <div className="accordion my-4 ">
          {/* Accordion Item 2 open*/}
          {/* <h2 className="accordion-header py-2">Step:2</h2> */}
          <div className="accordion-item mb-4 border-radius-16px border-lavender-blue box-shadow-33">
            <h2 className="accordion-header py-0">
              <button
                className={`accordion-button ${openItem === "transaction" ? "" : "collapsed"} align`}
                type="button"
                onClick={() =>
                  setOpenItem(openItem === "transaction" ? null : "transaction")
                }
                style={{
                  cursor: panVerified ? "pointer" : "not-allowed",
                  color: panVerified ? "inherit" : "#ccc",
                  backgroundColor:
                    openItem === "transaction" ? "transparent" : "transparent",
                  border: "none",
                  boxShadow: "none",
                  color: "inherit",
                  outline: "none",
                }}
                // disabled={!summaryPhoto}
                disabled={!panVerified}
              >
                Get Transaction Details
                {/* {transactionPhoto && (
                  <i className="bi bi-check-circle-fill text-success ms-2 ">
                    Success
                  </i>
                )} */}
                {transactionPhoto && (
                  <span className="text-success ms-2 d-inline-flex align-items-center">
                    <i className="bi bi-check-circle-fill me-1"></i>
                    Success
                  </span>
                )}
              </button>
            </h2>
            <div
              className={`accordion-collapse collapse m-2 ${openItem === "transaction" ? "show" : ""}`}
            >
              <div
                //   className="w-100 mt-4"
                className="text-start mt-4"
              >
                {/* <PrimaryButton
                  label="Transaction QR"
                  className="padding-12px-tb w-100"
                  //   onPress={() => _GenerateQR("transaction")}
                  onPress={() => {
                    _GenerateQR("transaction");

                    // Enable upload after delay
                    // setTimeout(() => {
                    //   setTransactionQRGenerated(true);
                    // }, 5000); // ⏳ 3 seconds delay (you can change)
                    
                  }}
                  disabled={isTransactionType}
                  showLoader={false}
                  {isTransactionType && (
                     <i className="bi bi-check-circle-fill text-success me-2 p-2"></i>
                     )
                  }
                /> */}

                <PrimaryButton
                  label={
                    isTransactionType ? (
                      <>
                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                        Transaction QR
                      </>
                    ) : (
                      "Transaction QR"
                    )
                  }
                  className={style.submit_btn}
                  //   style={{
                  //     maxWidth: "200px",
                  //     width: "100%",
                  //   }}
                  onPress={() => _GenerateQR("transaction")}
                  disabled={isTransactionType || qrLoader}
                  showLoader={qrLoader}
                />
              </div>
              <div className="col-sm-6 pt-4">
                <CustomFileInput
                  label="Upload your transaction QR"
                  postfix="*"
                  file={transactionPhoto}
                  error={transactionPhotoError}
                  id="transaction-qr-upload"
                  accept=".png, .jpg, .jpeg"
                  onFileChange={(file) => handlePhoto(file, "transaction")}
                  clear={() => {
                    setTransactionPhoto("");
                    setTransactionPhotoUrl("");
                    sessionStorage.removeItem("external_transaction_photo");
                    sessionStorage.removeItem("external_transaction_photo_url");
                  }}
                  //   disabled={!transactionQRGenerated}
                  disabled={!transactionQRGenerated}
                />
                {uploadLoader && (
                  <div className="mt-2 text-primary">
                    <div className="spinner-border spinner-border-sm me-2"></div>
                    Uploading QR...
                  </div>
                )}
                {/* {transactionPhotoUrl && <img src={transactionPhotoUrl} alt="Transaction QR" style={{ width: 150, height: 150, objectFit: "contain", marginTop: "8px" }} />} */}
              </div>
            </div>
          </div>
          {/* Accordion Item 2 closed*/}

          <div
            //   className="d-flex justify-content-center align-items-center my-4 w-100"
            className="text-start"
          >
            <PrimaryButton
              label="Submit"
              className={style.submit_btn}
              //   className="padding-10px-tb padding-34px-lr w-max-content mx-auto"
              disabled={!transactionPhoto}
              showLoader={false}
              onPress={handleFinalSubmit}
            />
          </div>
          <p className="color-eerie-black e-font-14 e-line-height-20 e-montserrat-regular mb-0 text-center pt-3">
            Upload transaction QR to enable submit{" "}
          </p>
        </div>
      </div>
    </>
  );
}

export default ImportExternalFundsModal;
